<template>
  <product-section-card
    v-if="branch?.tags"
    :title="$t('branch_detail.recommendation.similar_categories')"
    class="product-section-similar-categories <md:pb-0"
  >
    <div class="flex items-center gap-2 py-2 overflow-y-auto">
      <etg-button v-for="tag in branch.tags" :key="tag.id" :to="`/regions/${regionId}/tags/${tag.id}`" type="secondary" size="small">
        {{ tag.name }}
      </etg-button>
    </div>
  </product-section-card>
</template>

<script lang="ts" setup>
import ProductSectionCard from '@/components/product/product-detail/product-section-card.vue'

const { branch } = useBranchDetailContext()
const { regionId } = useRegion()
</script>
